import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SerieDocumentoInput } from 'sharedComponents/inputs/text'

import { KeyEventUtil } from 'utils'

const SerieDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-numeroDocumento', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='SERIE' md={4} htmlFor='input-serieDocumento' alignRightAt='md' />
      <Col md={8}>
        <Field name='serieDocumento'>
          {({ field }) => (
            <SerieDocumentoInput
              {...field}
              id='input-serieDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              setFieldValue={setFieldValue}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SerieDocumentoFormGroup)
